'use client';


import Icon from '@/components/ui/AppIcon';

interface ConsultationTypeCardProps {
  icon: string;
  title: string;
  description: string;
  isSelected: boolean;
  onSelect: () => void;
}

export default function ConsultationTypeCard({
  icon,
  title,
  description,
  isSelected,
  onSelect,
}: ConsultationTypeCardProps) {
  return (
    <button
      onClick={onSelect}
      className={`w-full p-6 rounded-lg border-2 transition-all duration-300 text-left ${
        isSelected
          ? 'border-primary bg-surface shadow-natural-lg'
          : 'border-border bg-card hover:border-secondary hover:shadow-natural'
      }`}
    >
      <div className="flex items-start space-x-4">
        <div
          className={`flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center ${
            isSelected ? 'bg-primary text-primary-foreground' : 'bg-surface text-primary'
          }`}
        >
          <Icon name={icon as any} size={24} />
        </div>
        <div className="flex-1">
          <h3 className="font-heading font-semibold text-lg text-text-primary mb-2">
            {title}
          </h3>
          <p className="text-sm text-text-secondary">{description}</p>
        </div>
        <div
          className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${
            isSelected
              ? 'border-primary bg-primary' :'border-border bg-card'
          }`}
        >
          {isSelected && (
            <Icon name="CheckIcon" size={16} className="text-primary-foreground" />
          )}
        </div>
      </div>
    </button>
  );
}